import Star from './Svg/Star';
import styles from 'styles/modules/ProfileTag.module.scss';
import SvgDiamond from './Svg/diamond';

const LegendIcon = () => (
    <svg
        width="7"
        height="7"
        viewBox="0 0 7 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.01331 5.03125L5.90109 5.51797C5.87812 5.61728 5.78974 5.6875 5.6878 5.6875H1.3128C1.21087 5.6875 1.12249 5.61728 1.09952 5.51797L0.987305 5.03125H6.01331Z"
            fill="white"
        />
        <path
            d="M6.55715 2.67442L6.11418 4.59395H0.886052L0.443083 2.67442C0.423614 2.58976 0.455989 2.50139 0.52577 2.44955C0.59577 2.3977 0.689614 2.39223 0.764864 2.43533L2.11871 3.20905L3.3179 1.41026C3.35705 1.35164 3.4218 1.31533 3.49202 1.3127C3.5629 1.30964 3.62961 1.34158 3.67271 1.39714L5.07905 3.20533L6.22246 2.4432C6.29705 2.39376 6.3944 2.3942 6.46811 2.44517C6.54205 2.49614 6.57705 2.58714 6.55715 2.67442Z"
            fill="white"
        />
    </svg>
);

const ProfileTag = ({ image, plan, name, classes = [], isEmbed = false }) => {
    const getAvatarClassName = () => {
        const baseClass = isEmbed ? styles.imgEmbed : styles.img;
        if (!plan) return baseClass;

        const planClasses = {
            legend: isEmbed ? styles.avatarLegendEmbed : styles.avatarLegend,
            platinum: isEmbed
                ? styles.avatarPlatinumEmbed
                : styles.avatarPlatinum,
        };

        return planClasses[plan.type] || baseClass;
    };

    const renderTag = () => {
        if (!plan) return null;

        const tagConfig = {
            contributing_editor: {
                className: styles.imgTag,
                Icon: Star,
                text: 'Pro',
            },
            platinum: {
                className: styles.imgTagPlatinum,
                Icon: SvgDiamond,
                text: 'Platinum',
            },
            premium: {
                className: styles.imgTagPremium,
                Icon: Star,
                text: 'Plus',
            },
            legend: {
                className: styles.imgTagLegend,
                Icon: LegendIcon,
                text: 'Legend',
            },
        };

        const config = tagConfig[plan.type];
        if (!config) return null;

        return (
            <span className={config.className}>
                <config.Icon />
                {config.text}
            </span>
        );
    };

    return (
        <div className={styles.imgWrapper}>
            <div className={[getAvatarClassName(), ...classes].join(' ')}>
                <img src={image} alt={name} />
            </div>
            {!isEmbed && renderTag()}
        </div>
    );
};

export default ProfileTag;
